import { render, staticRenderFns } from "./ConferenceRoomsEdit.vue?vue&type=template&id=0ca0ad57&scoped=true"
import script from "./ConferenceRoomsEdit.vue?vue&type=script&lang=js"
export * from "./ConferenceRoomsEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca0ad57",
  null
  
)

export default component.exports